import { render, staticRenderFns } from "./module_column.vue?vue&type=template&id=63e3279c"
import script from "./module_column.vue?vue&type=script&lang=js"
export * from "./module_column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports